export default __webpack_public_path__ + "static/media/Punto_09_Mercato_Centrale_FRA_Def.2a430d58.aac";